import { UserStatusReason } from '@lib/interfaces';

export const CannotUpdateSensitiveFieldStatusReasonCodes = [
    // User can only update specific fields

    UserStatusReason.A0,
    UserStatusReason.A1,
    UserStatusReason.A2,
    UserStatusReason.A3,
    UserStatusReason.A4,
    UserStatusReason.A5,
    UserStatusReason.A6,
    UserStatusReason.A7,
    UserStatusReason.A8,
    UserStatusReason.B3,
    UserStatusReason.B6,
    UserStatusReason.B7,
    UserStatusReason.B8,
    UserStatusReason.B9,
    UserStatusReason.B10,
    UserStatusReason.B2E,
    UserStatusReason.B0E,
    UserStatusReason.B9E,
    UserStatusReason.B10E,
    UserStatusReason.O1,
];

export const CannotUpdateAnyFieldStatusReasonCodes = [
    // User can not update any field

    UserStatusReason.S0,
    UserStatusReason.S1,
    UserStatusReason.S2,
    UserStatusReason.S3,
    UserStatusReason.S4,
    UserStatusReason.S5,
    UserStatusReason.S6,
    UserStatusReason.T0,
    UserStatusReason.T1,
    UserStatusReason.T2,
    UserStatusReason.T3,
    UserStatusReason.T4,
    UserStatusReason.T5,
    UserStatusReason.T6,
    UserStatusReason.T7,
    UserStatusReason.T8,
    UserStatusReason.T9,
    UserStatusReason.T10,
    UserStatusReason.T11,
    UserStatusReason.T12,
    UserStatusReason.T12E,
    UserStatusReason.T13,
    UserStatusReason.T13E,
];

export const CustomerActiveStatus = [
    { key: 'AO', value: 'First time activation' },
    { key: 'A1', value: 'Resumed from Suspended status' },
    { key: 'A2', value: 'Admin Activated the user from status suspended' },
    { key: 'A3', value: 'Admin activated the user by manual intervention from the dashboard' },
    { key: 'A4', value: 'Admin Activated the business user from status suspended' },
    { key: 'A5', value: 'Admin Activated' },
    { key: 'A6', value: 'Document expired or about to expire' },
    { key: 'A7', value: 'ID renewed' },
    { key: 'A8', value: 'ID re-verification failed after document expiration' },
    { key: 'A1I', value: 'Passport Under Review' },
    { key: 'A1R', value: 'Passport Rejected' },
];

export const CustomerActiveUnverifiedToVerified = [{ key: 'A0', value: 'Verified' }];

export const CustomerUnverified = [{ key: 'A10', value: 'User Unverified' }];

export const CustomerSuspendStatus = [
    { key: 'S0', value: 'Temporary suspension: initiated by the user or system user or the system' },
    { key: 'S1', value: 'Inactivity over time' },
    { key: 'S2', value: 'Suspicious activity was identified' },
    { key: 'S3', value: 'Admin rejected due to ID verification failed' },
    { key: 'S4', value: 'Admin suspended due to fraudulent activity' },
    { key: 'S5', value: 'Admin rejected due to ID verification failed' },
    { key: 'S6', value: 'Admin suspended due to certain reason' },
];

export const CustomerTerminateStatus = [
    { key: 'T0', value: 'Closed by user' },
    { key: 'T1', value: 'Closed by issuer' },
    { key: 'T2', value: 'Failed KYC' },
    { key: 'T3', value: 'Terminated by Admin' },
    { key: 'T4', value: 'Terminated by Admin' },
    { key: 'T5', value: 'Admin terminated due to ID verification failed' },
    { key: 'T6', value: 'Admin terminated due to KYC failed' },
    { key: 'T7', value: 'Admin terminated due to limited time exceeded and action taken for ID verification fail' },
    { key: 'T8', value: 'Admin terminated due to KYC OGS response' },
    { key: 'T9', value: 'Admin terminated due to ID verification failed' },
    { key: 'T10', value: 'Admin terminated due to limited time exceeded and action taken for KYB fail' },
    { key: 'T11', value: 'Admin terminated due to certain reason' },
];

export const PENDINGIDVToPENDINGKYC = [{ key: 'B3', value: 'Admin approved, proceed to KYC verification flow. Send an API call to Perform KYC' }];
export const PENDINGIDVToSUSPEND = [{ key: 'S5', value: 'Admin rejected due to ID verification failed' }];
export const PENDINGIDVToTERMINATE = [{ key: 'T5', value: 'Admin terminated due to ID verification failed' }];
export const PENDINGIDVToTERMINATENEO = [{ key: 'T3', value: 'Terminated by Admin' }];
export const SUSPENDToACTIVE = [{ key: 'A2', value: 'Admin Activated the user from status suspended' }];
export const PENDINGKYCToTERMINATE = [{ key: 'T6', value: 'Admin terminated due to KYC failed' }];
export const SUSPENDToTERMINATE = [
    { key: 'T3', value: 'Terminated by Admin' },
    { key: 'T4', value: 'Terminated by Admin' },
    { key: 'T5', value: 'Admin terminated due to ID verification failed' },
    { key: 'T6', value: 'Admin terminated due to KYC failed' },
    { key: 'T7', value: 'Admin terminated due to limited time exceeded and action taken for ID verification fail' },
    { key: 'T8', value: 'Admin terminated due to KYC OGS response' },
    { key: 'T9', value: 'Admin terminated due to ID verification failed' },
    { key: 'T10', value: 'Admin terminated due to limited time exceeded and action taken for KYB fail' },
    { key: 'T11', value: 'Admin terminated due to certain reason' },
    { key: 'T12', value: 'System terminated due to ID verification rejected' },
    { key: 'T13', value: 'System terminated due to ID verification suspected' },
    { key: 'T12E', value: 'System terminated due to ID verification rejected after document expiration for identity verification (same as T12)' },
    { key: 'T13E', value: 'System terminated due to ID verification suspected after document expiration for identity verification (same as T13)' },
];
export const ACTIVEToSUSPEND = [
    { key: 'S0', value: 'Temporary suspension: initiated by the user or system user or the system' },
    { key: 'S1', value: 'Inactivity over time' },
];
export const ACTIVEToTERMINATE = [
    { key: 'T0', value: 'Closed by user' },
    { key: 'T1', value: 'Closed by issuer' },
    { key: 'T2', value: 'Failed KYC' },
    // { key: 'T3', value: 'Terminated by Admin' },
    // { key: 'T4', value: 'Terminated by Admin' },
    // { key: 'T5', value: 'Admin terminated due to ID verification failed' },
    // { key: 'T6', value: 'Admin terminated due to KYC failed' },
    // { key: 'T7', value: 'Admin terminated due to limited time exceeded and action taken for ID verification fail' },
    // { key: 'T8', value: 'Admin terminated due to KYC OGS response' },
    // { key: 'T9', value: 'Admin terminated due to ID verification failed' },
    // { key: 'T10', value: 'Admin terminated due to limited time exceeded and action taken for KYB fail' },
    // { key: 'T11', value: 'Admin terminated due to certain reason' },
    // { key: 'T12', value: 'System terminated due to ID verification rejected' },
    // { key: 'T13', value: 'System terminated due to ID verification suspected' },
    // { key: 'T12E', value: 'System terminated due to ID verification rejected after document expiration for identity verification (same as T12)' },
    // { key: 'T13E', value: 'System terminated due to ID verification suspected after document expiration for identity verification (same as T13)' },
];
export const PENDINGKYCToACTIVE = [{ key: 'A3', value: 'Admin activated the user by manual intervention from the dashboard' }];
export const PENDINGKYBToACTIVE = [{ key: 'A5', value: 'Admin Activated' }];
export const PENDINGKYBToSUSPEND = [
    { key: 'S3', value: 'Admin rejected due to ID verification failed' },
    { key: 'S4', value: 'Admin suspended due to fraudulent activity' },
    { key: 'S5', value: 'Admin rejected due to ID verification failed' },
    { key: 'S6', value: 'Admin suspended due to certain reason' },
];
export const PENDINGKYBToTERMINATE = [
    { key: 'T3', value: 'Terminated by Admin' },
    { key: 'T4', value: 'Terminated by Admin' },
    { key: 'T5', value: 'Admin terminated due to ID verification failed' },
    { key: 'T6', value: 'Admin terminated due to KYC failed' },
    { key: 'T7', value: 'Admin terminated due to limited time exceeded and action taken for ID verification fail' },
    { key: 'T8', value: 'Admin terminated due to KYC OGS response' },
    { key: 'T9', value: 'Admin terminated due to ID verification failed' },
    { key: 'T10', value: 'Admin terminated due to limited time exceeded and action taken for KYB fail' },
    { key: 'T11', value: 'Admin terminated due to certain reason' },
    { key: 'T12', value: 'System terminated due to ID verification rejected' },
    { key: 'T13', value: 'System terminated due to ID verification suspected' },
    { key: 'T12E', value: 'System terminated due to ID verification rejected after document expiration for identity verification (same as T12)' },
    { key: 'T13E', value: 'System terminated due to ID verification suspected after document expiration for identity verification (same as T13)' },
];
